import msgCfg from '@/config/msg.js';
import config from '@/config/config.js';
import api from '@/config/apiConfig.js';
import Cookies from 'js-cookie';
import axios from 'axios';
import util from './util';

let httpUtil = {};

let httpTimeout = "90000";
let httpTimeout2 = "300000";

// 登录
httpUtil.login = function (url, param, suc, err) {
	axios.post(url, param, {
			headers: {
				'Content-Type': 'application/json'
			},
			timeout: httpTimeout
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response.headers.authorization);
			} else {
				err(response.data.msg);
			}
		}).catch(function (error) {
			console.log(error);
			err(msgCfg.sysErr);
		});
};


// ajaxPost
httpUtil.ajaxPost = function (vm, url, param, suc) {
	axios.post(url, param, {
			headers: {
				'Content-Type': 'application/json',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
			}
		}).catch(function (error) {
			console.log(error);
			vm.fullscreenLoading = false;
			util.error(error);
		});
};


// ajaxPostFile
httpUtil.ajaxPostFile = function (vm, url, param, suc) {
	axios.post(url, param, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
			}
		}).catch(function (error) {
			console.log(error);
			vm.fullscreenLoading = false;
			util.error(error);
		});
};

// ajaxPostFile
httpUtil.ajaxPutFile = function (vm, url, param, suc) {
	axios.put(url, param, {
			headers: {
				'Content-Type': 'multipart/form-data',//application/x-www-form-urlencoded
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
			}
		}).catch(function (error) {
			console.log(error);
			vm.fullscreenLoading = false;
			util.error(error);
		});
	// $.ajax({
	//     url : url,   // 处理的请求路径
	//     type : "put" ,      // 此处发送的是PUT请求（可变更为其他需要的请求）
	//     headers: {
	//         'authorization': Cookies.get('slash_token')
	//     },
	//     data:param,
	//     success : function(data) {
	//         suc(data);
	//     } ,
	//     error : function(data) {

	//     }
	// }) ;
};
// ajaxGet
httpUtil.ajaxGet = function (vm, url, params, suc) {
	axios.get(url, {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout,
			params: params || {}
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
			}
		}).catch(function (error) {
			console.log(error);
			vm.fullscreenLoading = false;
			util.error(error);
		});
};


// ajaxGet
httpUtil.ajaxDelete = function (vm, url, suc) {
	axios.delete(url, {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout,
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
			}
		}).catch(function (error) {
			util.error(error);
			vm.fullscreenLoading = false;
		});
};

// ajaxGet
httpUtil.ajaxPut = function (vm, url, params, suc, err) {
	axios.put(url, params, {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout,
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
                vm.fullscreenLoading = false;
                if(err !== undefined){
                    err();
                }
			}
		}).catch(function (error) {
			util.error(error);
			vm.fullscreenLoading = false;
            if(err !== undefined){
                err();
            }
		});
};
// ajaxGet
httpUtil.ajaxPut2 = function (vm, url, params, suc, err) {
	axios.put(url, params, {
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'authorization': Cookies.get('slash_token')
		},
		timeout: httpTimeout,
	})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else if (response.data.status === 400) {
				//util.logOut(vm);
			}else {
				util.error(response.data.msg);
				vm.fullscreenLoading = false;
				if(err !== undefined){
					err();
				}
			}
		}).catch(function (error) {
		util.error(error);
		vm.fullscreenLoading = false;
		if(err !== undefined){
			err();
		}
	});
};


// ajaxGet
httpUtil.ajaxPatch = function (vm, url, params, suc, err) {
	axios.patch(url, params, {
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'authorization': Cookies.get('slash_token')
			},
			timeout: httpTimeout,
		})
		.then(function (response) {
			if (response.data.status === 200) {
				suc(response);
			} else if (response.data.status === 403) {
				util.logOut(vm);
			} else {
				util.error(response.data.msg);
                vm.fullscreenLoading = false;
                if(err !== undefined){
                    err();
                }
			}
		}).catch(function (error) {
			util.error(error);
			vm.fullscreenLoading = false;
            if(err !== undefined){
                err();
            }
		});
};


export default httpUtil;




// WEBPACK FOOTER //
// ./src/utils/httpUtil.js